import backendAPI from '../services/axiosInstance';
import { toast } from 'react-toastify';

/**
 * Save Workflow
 */
export const saveWorkflow = async (workflowData) => {
  try {
    const response = await backendAPI.post('/workflows/', workflowData);
    return response.data;
  } catch (error) {
    console.error('❌ Error saving workflow:', error.response?.data || error.message);
    toast.error('Failed to save workflow. Please try again.', { position: 'top-right', autoClose: 3000 });
    throw error;
  }
};


